import * as React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import KeyConstants from 'constants/KeyConstants';
import { KeyboardEventHandler } from 'types/typescript/eventHandlers';

export const layerStack: React.Component[] = [];

function withLayerHideOnEscapeTrigger(Child: React.ComponentType<any>): React.ComponentType<any> {
  class LayerHideOnEscapeTrigger extends React.Component<any> {
    displayName = `LayerHideOnEscapeTrigger(${((Child as unknown) as React.SFC).displayName})`;

    componentDidMount() {
      if (layerStack.length === 0) {
        document.addEventListener(
          'keydown',
          (this.handleDocumentKeyDown as unknown) as EventListener,
          false
        );
      }
      layerStack.push(this);
    }

    componentWillUnmount() {
      const index = layerStack.indexOf(this);
      if (index >= 0) {
        layerStack.splice(index, 1);

        if (layerStack.length === 0) {
          document.removeEventListener(
            'keydown',
            (this.handleDocumentKeyDown as unknown) as EventListener,
            false
          );
        }
      }
    }

    handleDocumentKeyDown: KeyboardEventHandler = event => {
      if (event.keyCode === KeyConstants.ESCAPE) {
        let l = layerStack.length;
        while (l--) {
          const layer: React.Component<any> = layerStack[l];
          if (layer) {
            if (!layer.props.onRequestHide) {
              console.warn(
                'component has hideOnEscapeTrigger without onRequestHide',
                ((layer as unknown) as React.SFC).displayName
              );
              continue;
            }
            event.preventDefault();
            // $FlowFixMe type the layerStack
            layer.props.onRequestHide();
            break;
          }
        }
      }
    };

    render() {
      return <Child {...this.props} />;
    }
  }
  return hoistNonReactStatic(LayerHideOnEscapeTrigger, Child);
}

export default withLayerHideOnEscapeTrigger;
